<ng-container *ngIf="job">
<div class="pl-4">
    <tabset class="job-boards-filters-tabs">
        <tab heading="Basic Filters" [active]="activeFilterTab === 0" (select)="activeFilterTab = 0">
            <div class="row job-boards-filters-tab">
                <div class="col-xs-12" style="margin-top:10px">
                    <div class="col-xs-6">
                        <div class="col-xs-6">
                            <label for="resumesPullCount" class="control-label">Resumes to pull from each job board:
                            </label>
                        </div>
                        <div class="col-xs-6" *ngIf="isEditable">
                            <select class="form-control job-board-input-control" [(ngModel)]="job.resumesToPullPerJobBoardCount"
                                name="resumesPullCount" id="resumesPullCount">
                                <option *ngFor="let resumePullCount of resumePullOptions" [ngValue]="resumePullCount">{{resumePullCount}}</option>
                            </select>
                        </div>
                        <div class="col-xs-6" *ngIf="!isEditable">
                            <select class="form-control job-board-input-control" [(ngModel)]="savedResumePullCount"
                                name="resumesPullCount" id="resumesPullCount" disabled>
                                <option *ngFor="let resumePullCount of resumePullOptions" [ngValue]="resumePullCount">{{resumePullCount}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="col-xs-4">
                            <label for="recency" class="control-label"><i class="far fa-clock mr-1"></i>Recency: </label>
                        </div>
                        <div class="col-xs-4">
                            <select class="form-control job-board-input-control" [(ngModel)]="job.recency"
                                name="recency" id="recency" [disabled]="!isEditable">
                                <option *ngFor="let recency of recencyOptions" [ngValue]="recency">{{recency}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" style="margin-top:15px">
                    <div class="col-xs-6">
                        <div class="col-xs-6">
                            <label for="location" class="control-label"><i class="fa fa-map-marker-alt mr-1"></i>Location/Postcode:
                            </label>
                        </div>
                        <div class="col-xs-6">
                            <span [tooltip]="job.locationLabel" *ngIf="job.locationLabel !== '-'"
                                style="font-size: 12px; font-weight: bold; cursor:pointer;">
                                {{job.locationLabel}}
                            </span>
                            <span *ngIf="job.locationLabel == '-'">
                                Not Available
                            </span>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="col-xs-4">
                            <label for="degrees" class="control-label"><i class="fa fa-graduation-cap mr-1"></i>Education:
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div *ngFor="let degree of job.educationList" [hidden]="!(job.educationList != null && job.educationList.length > 0 && job.educationList[0].degreeName != null)">
                                <b class="emerald">{{degree.degreeName}}
                                    <span *ngIf="degree.institution != null && degree.institution.name != null">
                                        at {{degree.institution.name}}
                                    </span>
                                </b>
                            </div>
                            <b *ngIf="job.educationList == null || job.educationList.length == 0 || (job.educationList.length>0 && job.educationList[0].degreeName == null)">None</b>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" style="margin-top:20px;">
                    <div class="col-xs-6">
                        <div class="col-xs-6">
                            <label for="radius" class="control-label"><i class="fa fa-compass mr-1"></i>Radius: </label>
                        </div>
                        <div class="col-xs-6">
                            <select class="form-control job-board-input-control" [(ngModel)]="job.radius"
                                name="radius" id="radius" [disabled]="!isEditable">
                                <option *ngFor="let radius of radiusOptions" [ngValue]="radius">{{radius}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="col-xs-4">
                            <label for="industry" class="control-label">
                                <i class="fas fa-university mr-1"></i>
                                Industry:
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <span *ngIf="job.industry !== null && job.industry !== undefined">
                                {{job.industry}}
                            </span>
                            <span *ngIf="job.industry === null || job.industry === undefined">
                                Not Available
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" style="margin-top:20px;">
                    <div class="col-xs-6">
                        <div class="col-xs-6">
                            <label for="jobType" class="control-label">
                                <i class="fa fa-briefcase mr-1"></i>
                                Job Type:
                            </label>
                        </div>
                        <div class="col-xs-6">
                            {{job.jobType}}
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="col-xs-4">
                            <label for="salary" class="control-label">
                                <i class="far fa-money-bill-alt mr-1"></i>
                                Salary:
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <span *ngIf="job.salary !== null && job.salary !== undefined">
                                {{job.salary}}
                            </span>
                            <span *ngIf="job.salary === null || job.salary === undefined">
                                Not Available
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </tab>
        <tab heading="Advanced Filters" [active]="activeFilterTab === 1" (select)="activeFilterTab = 1">
            <div class="row job-boards-filters-tab">
                <div class="col-xs-12" style="margin:10px">
                    <div *ngIf="(job.daxtraParameters === null || job.advancedParametersImage === null)">
                        <p>No Advanced Filters Selected
                            <button class="btn btn-primary job-boards-edit-parameters-button" style="margin-left:10px" [disabled]="!isEditable" (click)="getJobBoardSearchInterface()">Add Filters</button>
                        </p>
                    </div>
                    <div *ngIf="job.daxtraParameters !== null && job.advancedParametersImage !== null" class="job-boards-advance-filter-actions">
                        <button class="btn btn-primary job-boards-edit-parameters-button" [disabled]="!isEditable"
                            (click)="getJobBoardSearchInterface()">Edit Filters</button>
                        <button class="btn btn-danger job-boards-edit-parameters-button" [disabled]="!isEditable"
                            (click)="clearJobBoardsSearchFilters()">Clear Filters</button>
                    </div>
                    <div *ngIf="job.daxtraParameters !== null && job.advancedParametersImage != null" class="job-boards-advance-filter-image">
                        <object [data]="job.advancedParametersImage" type="image/png" style="width:100%">
                        </object>
                    </div>
                </div>
            </div>
        </tab>
    </tabset>
</div>
<div class="row">
    <div class="col-xs-12 emerald">
        <h3 style="padding-left:25px; border-bottom:0px">
            <strong>Filters Supported by Job Boards</strong>
        </h3>
    </div>
    <div class="job-boards-flags-header" [ngClass]="{'col-xs-12': context =='global', 'col-xs-10': context =='editRequisition'}">
        <div class="row">
            <div class="col-xs-12" style="padding-left:11px">
                <div class="col-xs-2">
                </div>
                <div class="col-xs-1">
                    <i class="fa fa-map-marker-alt job-board-flag" [popover]="locationTpl" popoverTitle="Location"
                     placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="fa fa-map-pin job-board-flag" [popover]="postcodeTpl" popoverTitle="Postcode"
                     placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="fa fa-compass job-board-flag" popover="{{job.radius}}"
                        popoverTitle="Radius"  placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="fa fa-briefcase job-board-flag" popover="{{job.jobType}}"
                        popoverTitle="Job Type"  placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="far fa-clock job-board-flag" popover="{{job.recency}}"
                        popoverTitle="Recency"  placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="fa fa-graduation-cap job-board-flag" [popover]="educationTpl"
                        popoverTitle="Education"  placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="fas fa-university job-board-flag" [popover]="industryTpl" popoverTitle="Industry"
                     placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
                <div class="col-xs-1">
                    <i class="far fa-money-bill-alt job-board-flag" [popover]="salaryTpl" popoverTitle="Salary"
                     placement="bottom" triggers="mouseenter:mouseleave" [outsideClick]="true" container="body">
                    </i>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 job-boards-flags-values">
                <div class="row">
                    <div class="col-xs-12" *ngFor="let jobBoard of job.jobBoardDetails" [hidden]="!isEditable">
                        <div class="col-xs-2 checkbox-nice">
                            <input type="checkbox" id="jobBoard-{{jobBoard.boardId}}" name="jobBoard-{{jobBoard.id}}"
                                (click)="onJobBoardSelectionChange()"
                                [(ngModel)]="jobBoard.enabled" />
                            <label for="jobBoard-{{jobBoard.boardId}}">
                                <span>{{jobBoard.sourceType}}</span>
                            </label>
                        </div>
                        <div class="col-xs-1">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[0])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[0])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[1])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[1])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[2])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[2])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[3])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[3])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[4])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[4])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[5])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[5])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[6])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[6])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[7])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[7])}" class="job-board-flag"></i>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12" *ngFor="let jobBoard of readOnlyJobBoardsData" [hidden]="isEditable">
                        <div class="col-xs-2 checkbox-nice">
                            <input type="checkbox" id="jobBoard-{{jobBoard.boardId}}-200" name="jobBoard-{{jobBoard.id}}-200"
                                [(ngModel)]="jobBoard.enabled" disabled />
                            <label class="license-pref-label-disabled" for="jobBoard-{{jobBoard.boardId}}-200">
                                <span>{{jobBoard.sourceType}} </span>
                            </label>
                        </div>
                        <div class="col-xs-1">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[0])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[0])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[1])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[1])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[2])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[2])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[3])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[3])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:10px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[4])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[4])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[5])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[5])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[6])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[6])}" class="job-board-flag"></i>
                        </div>
                        <div class="col-xs-1" style="padding-left:12px">
                            <i [ngClass]="{'fa fa-check text-success': (jobBoard.flags && jobBoard.flags[7])}" class="job-board-flag"></i>
                            <i [ngClass]="{'fas fa-times text-danger': !(jobBoard.flags && jobBoard.flags[7])}" class="job-board-flag"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="col-xs-8 col-xs-offset-4 job-boards-actions-container">
    <div class="col-xs-12 job-boards-actions">
        <button class="btn btn-primary" (click)="launchJobBoardSearchHistory()">View History</button>
    </div>
</div>
</ng-container>

<ng-template #industryTpl>
    <span *ngIf="job.industry !== null && job.industry !== undefined">  {{job.industry}}</span>
    <span *ngIf="job.industry === null || job.industry === undefined">  Not Available</span>
</ng-template>

<ng-template #salaryTpl>
    <span *ngIf="job.salary !== null && job.salary !== undefined">  {{job.salary}}</span>
    <span *ngIf="job.salary === null || job.salary === undefined">  Not Available</span>
</ng-template>

<ng-template #educationTpl>
    <div *ngFor="let degree of job.educationList" [hidden]="!(job.educationList != null && job.educationList.length > 0 && job.educationList[0].degreeName != null)">
        <b>{{degree.degreeName}}
            <span *ngIf="degree.institution != null && degree.institution.name != null">
                at {{degree.institution.name}}
            </span>
        </b>
    </div>
    <div *ngIf="job.educationList == null || job.educationList.length == 0 || (job.educationList.length>0 && job.educationList[0].degreeName == null)">None</div>
</ng-template>

<ng-template #locationTpl>
    <span *ngIf="job.locationLabel !== '-'">
            {{job.locationLabel}}
    </span>
    <span *ngIf="job.locationLabel == '-'">
            Not Available
    </span>
</ng-template>

<ng-template #postcodeTpl>
    <div *ngIf="job.location != null && job.location.zipcode != null" class="text-center">
        {{job.location.zipcode}}
    </div>
    <div *ngIf="job.location === null || job.location.zipcode === null">
        Not Available
    </div>
</ng-template>

<ng-template #searchInterfaceModal>
    <div class="modal-header main-modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeSearchInterfaceModal()">×</button>
        <h4 class="modal-title wrap-text-in">Advanced Job Boards Filters</h4>
    </div>

    <div class="modal-body">
        <div id="dynamicContentForJobBoardSearch">
        </div>
        <form role="form" id="jobBoardSearchForm" name="searchForm" *ngIf="!loadingSearchInterfaceFlag" novalidate>
            <div class="row">
                <div class="col-xs-12">
                    <div class="main-box" id="daxtra-ui" style="overflow: scroll;height: 400px;">
                        <div class="main-box-body">
                            <div [innerHTML]="searchHtml"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="submit" class="btn btn-success" (click)="saveAdvancedSearchParams()" [disabled]="savingFlag">
                            <span *ngIf="!savingFlag">Save Advanced Search Parameters</span>
                            <span *ngIf="savingFlag">Saving..</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row skeleton-container" *ngIf="loadingSearchInterfaceFlag">
            <div class="col-xs-12">
                <div class="main-box" style="height: 400px; padding: 15px;">
                    <div class="skeleton-heading skeleton-loading" style="width:50%; margin-bottom:20px"></div>
                    <div class="skeleton-paragraph skeleton-loading" style="margin-bottom:12px"></div>
                    <div class="skeleton-paragraph skeleton-loading" style="width:80%; margin-bottom:12px"></div>
                    <div class="skeleton-paragraph skeleton-loading" style="width:60%; margin-bottom:12px"></div>
                    <div class="skeleton-paragraph skeleton-loading" style="width:90%; margin-bottom:12px"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #searchHistoryModal>
    <div class="modal-header main-modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeSearchHistoryModal()">×</button>
        <h4 class="modal-title wrap-text-in">Job Boards Search History</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12">
                <div class="main-box-body">
                    <app-job-boards-search-history [jobId]="job.id" [jobTitle]="job.title" [clientOrBuName]="job.clientorbu?.name || ''"></app-job-boards-search-history>
                </div>
            </div>
        </div>
    </div>
</ng-template>
